<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Tambah Blast List
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <form @submit.prevent="createBlastList">
                            <div class="form-group">
                                <label for="name">Nama Blast List</label>
                                <input type="text" class="form-control" id="name" v-model="form.name" required>
                            </div>
                            <div class="form-group">
                                <label for="description">Deskripsi</label>
                                <textarea class="form-control" id="description" v-model="form.description" rows="3"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="status">Status</label>
                                <select class="form-control" id="status" v-model="form.status" required>
                                    <option value="draft">Draft</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <button type="submit" class="btn btn-primary" :disabled="loading">
                                    <span v-if="loading">Menyimpan...</span>
                                    <span v-else>Simpan</span>
                                </button>
                                <router-link to="/blast-list" class="btn btn-secondary ml-2">Batal</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                form: {
                    name: '',
                    description: '',
                    status: 'draft'
                }
            };
        },
        methods: {
            async createBlastList() {
                this.loading = true;
                try {
                    let response = await this.$store.dispatch('blast_list_create', this.form);
                    this.$toast.success(response.data.message);
                    this.$router.push('/blast-list');
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || 'Server error');
                }
                this.loading = false;
            }
        }
    };
</script>


